<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
    <circle cx="15" cy="15" r="15" fill="#DBE7FD" />
    <path d="M10 10L20 20" stroke="#2B65EB" stroke-linecap="round" />
    <path d="M10 20L20 10" stroke="#2B65EB" stroke-linecap="round" />
  </svg>
</template>

<script>
export default { name: "CloseIcon" };
</script>
